exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone .dz-preview.dz-error .dz-error-message{display:none!important}.vue-dropzone>.dz-preview .dz-remove{opacity:1!important}.filters{color:#000!important}.filters:hover{color:var(--v-primary-base)!important}", ""]);

// exports
